import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  Grid, Typography,
  FormControlLabel, Switch, StepConnector,
  Accordion, AccordionSummary, AccordionDetails
} from '@material-ui/core'

import { withStyles, makeStyles } from '@material-ui/core/styles'

import clsx from 'clsx'
import PropTypes from 'prop-types'
// Icons
import { CheckCircle } from '@material-ui/icons'

import CiscoNew from './CiscoNew'
import CiscoConfiguration from './CiscoConfiguration'

import { parseUnitInfo } from '../../../../../utils'
import { updateCiscoOrgSetup, deleteCiscoSettings } from '../../../../../redux/actions'
import { Toast as NotificationToast, CiscoIcon, ConfirmToast, ModalToast } from '../../../tools'
import { cloneDeep } from 'lodash'

const StyledSwitch = withStyles({
  switchBase: {
    color: 'white',
    '&$checked': {
      color: '#A4D164'
    },
    '&$checked + $track': {
      backgroundColor: '#A4D164'
    }
  },
  checked: {},
  track: {}
})(Switch)

const useStyles = makeStyles((theme) => ({
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    }
  },
  heading: {
  },
  subHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    textTransform: 'none'
  },
  generalFields: {
    width: '100%'
  },
  phoneInput: {
    width: '100%'
  },
  roleContent: {
    width: '80%'
  },
  accordionHeader: {
    backgroundColor: theme.palette.background.default,
    borderRadius: '0.125em'
  },
  expandIcon: {
    '&$expanded': {
      transform: 'rotate(0deg)'
    }
  },
  expanded: {},
  accordionDetails: {
    textTransform: 'none',
    color: theme.palette.text.secondary
  },
  alertCard: {
    height: '4em'
  },
  uploadInput: {
    display: 'none'
  },
  imageNameAvatar: {
    background: theme.palette.background.paper,
    '&:hover': {
      background: theme.palette.background.default
    },
    '&.Mui-focused': {
      background: theme.palette.background.default
    }
  },
  stepperClassRoot: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  stepperClassActive: {
    backgroundImage:
      'linear-gradient(0deg, rgba(195,242,93,1) 0%, rgba(82,145,252,1) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
  },
  stepperClassCompleted: {
    backgroundImage:
      'linear-gradient(0deg, rgba(195,242,93,1) 0%, rgba(82,145,252,1) 100%)'
  },
  ciscoIcon: {
    width: '100%'
  },
  ciscoSwitch: {
    margin: theme.spacing('auto', 0, 'auto', 0)
  }
}))

const StepperConnector = withStyles({
  alternativeLabel: {
    top: 22
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient(0deg, rgba(195,242,93,1) 0%, rgba(82,145,252,1) 100%)'
    }
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient(0deg, rgba(195,242,93,1) 0%, rgba(82,145,252,1) 100%)'
    }
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1
  }
})(StepConnector)

/**
 * Returns user general info modal
 */
const CiscoSplash = ({ setSelectedForm }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const { ciscoUmbrellaSettings } = useSelector(state => state.integrations)
  // follow from initial settings object
  const ciscoUmbrellaForm = cloneDeep(ciscoUmbrellaSettings)

  const [form, setForm] = useState({ ...ciscoUmbrellaForm, initialized: false })

  const TreeData = useSelector(state => state.auth.unitTree)
  // Provides the correct stepper icons in the connector
  const stepperIcons = (props) => {
    const { active, completed } = props

    const icons = {
      1: <CheckCircle />,
      2: <CheckCircle />
    }

    return (
      <div
        className={clsx(classes.stepperClassRoot, {
          [classes.stepperClassActive]: active,
          [classes.stepperClassCompleted]: completed
        })}
      >
        {icons[String(props.icon)]}
      </div>
    )
  }

  stepperIcons.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool
  }

  // This is currently being used to capture the unit tree information to get the alerts
  const data = parseUnitInfo(TreeData)

  const fireCreateNewSuccess = () => {
    NotificationToast(false, 'Cisco Umbrella has been successfully integrated with Learnsafe.')
    setForm({ ...form, initialized: false })
  }

  const fireCreateNewFailure = () => {
    NotificationToast(true, 'Failed to Create The Cisco Umbrella Integration. Please check your settings and try again.')
  }

  const fireDeleteSuccess = () => {
    NotificationToast(false, 'Cisco Umbrella has been successfully removed from Learnsafe.')
    setForm({ ...form, summary: { ...form.summary, enabled: false }, initialized: false })
  }

  const fireDeleteFailure = () => {
    NotificationToast(true, 'Failed to Remove The Cisco Umbrella Integration. Please try again.')
  }

  const submitForm = async () => {
    const settings = Object.assign({}, form)
    dispatch(updateCiscoOrgSetup(settings, 'ciscoUmbrellaSettings', fireCreateNewSuccess, fireCreateNewFailure))
  }

  const handleInitialization = async (e) => {
    e.preventDefault()
    const newForm = { ...form }
    newForm.initialized = !newForm.initialized
    setForm(newForm)
  }

  const handleBackTrack = (e) => {
    e.preventDefault()
    setForm({ ...form, initialized: false })
  }

  const handleDeleteCisco = async () => {
    const results = await ConfirmToast({ msg: 'Are you sure you want to remove your Cisco integration?' })
    if (results) {
      console.log(results)
      dispatch(deleteCiscoSettings(fireDeleteSuccess, fireDeleteFailure))
      setForm({ ...form, initialized: false, summary: { ...form.summary, enabled: false } })
    }
  }

  const toggleCiscoUmbrella = async (e) => {
    if (e.target.checked) {
      if (ciscoUmbrellaSettings && ciscoUmbrellaSettings.summary && !ciscoUmbrellaSettings.summary.enabled) {
        await ModalToast('info', 'Cisco Umbrella must be configured!', 'Please configure and check all current settings.')
      }

      setForm({ ...form, summary: { ...form.summary, enabled: true } })
    } else {
      // require confirmation before deleting
      handleDeleteCisco()
    }
  }

  return (
    <>
      <Grid container direction='row'>
        <Grid item container direction='column' justify='flex-start' spacing={2} className='mx-auto w-100'>

          <Grid container item direction='row'>
            <Grid item>
              <h2>Integrations</h2>
            </Grid>
          </Grid>

          <Grid container item direction='row'>
            <Grid item xs={12}>
              <Accordion expanded={Boolean((ciscoUmbrellaSettings && ciscoUmbrellaSettings.summary && Boolean(ciscoUmbrellaSettings.summary.enabled)) || (form.summary && Boolean(form.summary.enabled)))} elevation={3}>
                <AccordionSummary className={classes.accordionHeader}>
                  <Grid container direction='row' spacing={1} alignItems='center' justify='space-between' className='mx-auto w-100'>
                    <Grid item>
                      <Grid container direction='row' spacing={1} className='m-auto w-100' alignItems='center'>
                        <Grid item className='pl-0 py-0'>
                          <CiscoIcon className={classes.ciscoIcon} />
                        </Grid>

                        <Grid item className='py-0 pr-0'>
                          <Typography variant='button' className='font-weight-bold'>BETA</Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item>
                      <FormControlLabel
                        control={
                          <StyledSwitch
                            checked={Boolean(form.summary.enabled)}
                            onChange={toggleCiscoUmbrella}
                          />
                        }
                        onClick={(e) => e.stopPropagation()}
                        className={classes.ciscoSwitch}
                        label={form.summary.enabled ? <span>Yes</span> : <span>No</span>}
                      />
                    </Grid>
                  </Grid>
                </AccordionSummary>

                <AccordionDetails className='p-0'>
                  <Grid container direction='row'>
                    {/* Setup Confirmation Dialog */}
                    {form.summary.enabled && form.initialized &&
                      <CiscoNew
                        classes={classes}
                        handleBackTrack={handleBackTrack}
                        stepperIcons={stepperIcons}
                        StepperConnector={StepperConnector}
                        ciscoNewForm={form}
                        setCiscoNewForm={setForm}
                        orgUnitInfo={data}
                        handleSubmit={submitForm}
                      />}
                    {/* Once config has been set, show them their current settings */}
                    {form.summary.enabled && !form.initialized &&
                      <CiscoConfiguration
                        ciscoIntegrationForm={form}
                        onConfigure={handleInitialization}
                        orgUnitInfo={data}
                      />}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>

        </Grid>
      </Grid>
    </>
  )
}

export default CiscoSplash
